import { ProductsFilterItem } from '@api/catalog';

import BasketButton from '@components/ProductCard/BasketButton';
import PriceItem from '@components/ProductCard/PriceItem';
import ProductMoreInfo from '@components/ProductCard/ProductCardMoreInfoModal';
import ProductCardTableCell from '@components/ProductCard/ProductCardTableCell';
import { Data, ExtendedRow } from '@components/Table';
import Tooltip from '@components/controls/Tooltip';

import { VIEW_OPTIONS } from '@scripts/enums/products';
import { Button, scale } from '@scripts/gds';
import { fromKopecksToRouble } from '@scripts/helpers';

import MoreInfoIcon from '@icons/24/more-info.svg';

export const columns = [
    {
        Header: 'Товар',
        accessor: 'name',
        disableSortBy: true,
        Cell: ({ row }: { row: Data }) => (
            <ProductCardTableCell image={row.original.main_image} productItem={row.original} />
        ),
    },
    {
        Header: 'Бренд',
        accessor: 'brand',
        disableSortBy: true,
        Cell: ({ row }: { row: ExtendedRow }) => (
            <p css={{ verticalAlign: 'center !important' }}>{row.values.brand?.name ? row.values.brand.name : '-'}</p>
        ),
    },
    {
        Header: 'Цена',
        accessor: 'base_price',
        disableSortBy: true,
        Cell: ({ value, row }: { value: Data; row: Data }) => (
            <PriceItem
                price={fromKopecksToRouble(value.price)}
                old_price={fromKopecksToRouble(value.cost)}
                percentEconomy={value.discount_percent}
                priceUnit={row.original.price_unit}
            />
        ),
    },
    {
        Header: '',
        accessor: 'brand_id',
        disableSortBy: true,
        Cell: ({ row }: { row: Data }) => <BasketButton productItem={row.original} activeView={VIEW_OPTIONS.DEFAULT} />,
    },
    {
        Header: '',
        accessor: 'settings',
        disableSortBy: true,
        Cell: ({ row }: { row: Data }) => (
            <Tooltip
                arrow
                theme="light"
                placement="bottom-end"
                trigger="click"
                minWidth={scale(36)}
                delay={15}
                content={<ProductMoreInfo productItem={row.original} />}
                css={{
                    maxWidth: 'none !important',
                    padding: 0,
                    '& > .tippy-content': {
                        padding: 0,
                    },
                }}
            >
                <Button type="button" css={{ backgroundColor: '#fff !important' }}>
                    <MoreInfoIcon />
                </Button>
            </Tooltip>
        ),
    },
];

export const prepareFilters = (filters: ProductsFilterItem) => [
    {
        code: 'brand_id',
        name: 'Бренд',
        values: filters?.brands.map(item => ({ ...item, code: item.id })) || [],
    },
    ...(filters?.facet_props
        .filter(item => item.name && item.values.length > 0)
        .map(item => ({
            ...item,
            values: item.values.map(el => {
                if (el.name === 'true') {
                    return { ...el, name: 'Да' };
                } else if (el.name === 'false') {
                    return { ...el, name: 'Нет' };
                }

                return el;
            }),
        })) || []),
];
